export const tabList = [
    {
      key: "codigos-pokemon",
      label: "Codigos Pokemon",
    },
    {
      key: "codigos-objetos",
      label: "Codigos Objetos",
    },
    {
      key: "codigos-gacha",
      label: "Gachapones",
    },
    {
      key: "historico-gachapon",
      label: "Historico Gachapon",
    },
];